<template>
  <div>

    <div class="pagando-select" id="floatingSelect" style="width:100%;">
      <div class="pagando-select-inner">
        <div class="select-btn" id="selectBtn" onclick="activeSelectBtn()">
          <span id="selectValue">
            <img
              class="plugin-img"
              src="./../assets/magento-logo.svg"
              alt="Logo del plugin de magento"
              height="40"
              width="140"
            />
          </span>
          <div class="btn-container">
            <a href="/">
              <img
                class="plugin-img"
                src="./../assets/api-logo.svg"
                alt="Logo de pagando check api"
                height="40"
                width="140"
              />
            </a>
            <a href="/prestashop">
              <img
                class="plugin-img"
                src="./../assets/prestashop-logo.svg"
                alt="Logo del plugin de prestashop"
                height="40"
                width="175"
              />
            </a>
            <a href="/woocommerce">
              <img
                class="plugin-img"
                src="./../assets/woocommerce-logo.svg"
                alt="Logo del plugin de woocomerce"
                height="40"
                width="175"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- https://static-docs.pagandocheck.com/api/magento-plugin/swagger.yml -->
    <rapi-doc
      id="rapi-doc"
      spec-url="specs/magento/swagger.yml"
      render-style="read"
      theme="light"
      info-description-headings-in-navbar="true"
      sort-endpoints-by="method"
      schema-style="table"
      layout="column"
      show-header ="false"
      allow-authentication="false"
      allow-server-selection="false"
      allow-spec-file-load="false"
      allow-spec-url-load="false"
      allow-search="true"
      style="height:100vh; width:100%"
      regular-font="Poppins"
      nav-bg-color="#ffffff"
      nav-hover-text-color="#00DEFE"
      primary-color="#00DEFE"
      header-color="#50C14F"
      nav-accent-color="#00DEFE"
      nav-item-spacing="relaxed"
      nav-text-color="#BBBBCC"
      update-route="false"
    >
      <div slot="tag--Autenticación">
        <input class='txt pull-left' id='key-val-input' type='text' value="Bearer ">
        <!-- <button class='btn pull-right' onclick='setApiKey()' > Cargar </button > -->
        <button class='btn pull-right' v-on:click="diHola()" > Cargar </button >
      </div>
    </rapi-doc>
    <div class="white-space" id="whiteSpace">
    </div>
    <div class="footer-pagando">
      <div class="inner-footer">
        <div class="top-container">
          <div class="info-side">
            <div class="title">
              ¿Ya lo decidiste? Contacta a ventas
            </div>
            <div class="info">
              Contáctanos al correo
              <a href="mailto:ventas@pagandocheck.com"
                >ventas@pagandocheck.com</a
              >
              o al teléfono <a href="tel:8003230709">(800) 323 0709</a> desde el
              interior de la republica.
            </div>
          </div>
          <div class="img-side">
            <img
              alt="Ilustracion de soporte de pagando"
              src="./../assets/support.png"
              height="155"
              width="190"
            />
          </div>
        </div>
        <div class="bottom-container">
          <div class="first-container">
            <img
              alt="Logo de pagando check"
              src="./../assets/logo-pagando-check-white.svg"
              height="64"
              width="167"
            />
            <div class="small-info">
              <div class="green-title" style="margin-bottom: 20px">
                Vendes más, seguro.
              </div>
            </div>
            <div class="social-btn">
              <a href="https://pt-br.facebook.com/PagandoCheck">
                <img
                  alt="Icono de Facebook"
                  src="./../assets/fb-icon.svg"
                  height="40"
                  width="40"
                />
              </a>
              <a href="https://www.instagram.com/pagandocheck/">
                <img
                  alt="Icono de Instagram"
                  src="./../assets/ig-icon.svg"
                  height="40"
                  width="40"
                />
              </a>
              <a href="https://github.com/pagandocheck/">
                <img
                  alt="Icono de Github"
                  src="./../assets/github-icon.svg"
                  height="40"
                  width="40"
                />
              </a>
              <a href="https://gitlab.com/pagandocheck/">
                <img
                  alt="Icono de Gitlab"
                  src="./../assets/gitlab-icon.svg"
                  height="40"
                  width="40"
                />
              </a>
            </div>
          </div>
          <div class="second-container">
            <div class="small-title">
              Inicio
            </div>
            <ul>
              <li>
                <a href="https://www.pagandocheck.com/">
                  Inicio
                </a>
              </li>
              <li>
                <a href="https://www.pagandocheck.com/pagando-check-pro/">
                  Terminal de Pagos
                </a>
              </li>
              <li>
                <a href="https://docs.pagandocheck.com/">
                  API de pagos
                </a>
              </li>
              <li>
                <label for="modal-1">Plugin de Pagos</label>
              </li>
            </ul>
          </div>
          <div class="third-container">
            <div class="small-title">
              Empresa
            </div>
            <ul>
              <li>
                <a href="https://www.pagandocheck.com/aviso-de-privacidad/">
                  Aviso de Privacidad
                </a>
              </li>
              <li>
                <a href="https://www.pagandocheck.com/terminos-y-condiciones/">
                  Términos y Condiciones
                </a>
              </li>
            </ul>
          </div>
          <div class="fourth-container">
            <div class="small-title">
              Soporte
            </div>
            <ul>
              <li>
                <a href="https://www.pagandocheck.com/contacto-pagando-check/">
                  Contacto
                </a>
              </li>
              <li>
                <a href="https://soporte.pagandocheck.com/hc/es-mx">
                  Preguntas Frecuentes
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="bottom-footer-information" style="">
          <p>
            PAGANDO CHECK® incluyendo todos los derechos de propiedad
            intelectual del sitio web signos distintivos, dibujos, diseños,
            fotografías, imágenes, información, textos, música, videos, obras
            autorales y artísticas, materiales y demás contenido son propiedad
            de XC Networks, S.A. de C.V., IFPE, y usados por Black Labs, S.A. de
            C.V. en su carácter de licenciatario autorizado. <br />
            XC Networks, S.A. de C.V., IFPE © 2023 todos los derechos
            reservados.
          </p>
          <a
            class="hover-scale"
            href="https://gmsectec.badgr.com/public/assertions/ExWFlj3QQq-HuNpkUfkG-g"
          >
            <img alt="PCI" src="./../assets/pci.svg" height="60" width="290" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "rapidoc";

export default {
  name: 'Magento',
  components: {
  },
  methods:{
    diHola(){
      const docEl = document.getElementById('rapi-doc');
      const keyInputEl = document.getElementById('key-val-input');

      docEl.setAttribute('api-key-name','Authorization');
      docEl.setAttribute('api-key-location','header');
      docEl.setAttribute('api-key-value', keyInputEl.value);
      console.log("keyInputEl.value", keyInputEl.value);
    }
  }
}
</script>

<style>
  rapi-doc::part(section-navbar) {
    background-image: url("./../assets/bg-navbar.png");
    background-repeat: no-repeat;
    background-size: cover;
  }
</style>
